import { PublishSubscriptionStoreState } from "imagica-corekit/dist/cases/store/PublishSubscriptionStore";
import styles from "./AccountStatus.module.scss";

export function PerMonth(props: { state: PublishSubscriptionStoreState }): React.JSX.Element {
  return (
    <div className={styles.per}>
      <div className={styles.money}>${props.state.price}</div>
      <div className={styles.unit}>
        <div>per</div>
        <div>month</div>
      </div>
    </div>
  );
}
